import { render, staticRenderFns } from "./InviteDetails.vue?vue&type=template&id=356bfd14&scoped=true&"
import script from "./InviteDetails.vue?vue&type=script&lang=js&"
export * from "./InviteDetails.vue?vue&type=script&lang=js&"
import style0 from "./InviteDetails.vue?vue&type=style&index=0&id=356bfd14&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356bfd14",
  null
  
)

export default component.exports